const i18n = {
  'en-US': {
    'login.form.title': 'Login',
    'login.form.userName.errMsg': 'Username cannot be empty',
    'login.form.password.errMsg': 'Password cannot be empty',
    'login.form.login.errMsg': 'Login error, please refresh and try again',
    'login.form.userName.placeholder': 'Username: admin',
    'login.form.password.placeholder': 'Password: admin',
    'login.form.rememberPassword': 'Remember password',
    'login.form.forgetPassword': 'Forgot password',
    'login.form.login': 'login',
    'login.form.register': 'register account',
    'login.banner.slogan1': 'You should still have dreams. What if they come true?',
    'login.banner.subSlogan1': 'If life strips away ideals, dreams and fantasies, then life is just an empty shell.',
    'login.banner.slogan2': 'Constant dripping wears away the stone not by force but because of perseverance day and night.',
    'login.banner.subSlogan2': 'As long as you keep working hard and striving unremittingly, there is nothing you can\'t conquer.',
    'login.banner.slogan3': 'Life is not all roses; there are prickly thorns as well.',
    'login.banner.subSlogan3': 'Behind every effort, there must be double rewards.'
  },
  'zh-CN': {
    'login.form.title': '登录',
    'login.form.userName.errMsg': '用户名不能为空',
    'login.form.password.errMsg': '密码不能为空',
    'login.form.login.errMsg': '登录出错，请刷新重试',
    'login.form.userName.placeholder': '用户名：admin',
    'login.form.password.placeholder': '密码：admin',
    'login.form.rememberPassword': '记住密码',
    'login.form.forgetPassword': '忘记密码',
    'login.form.login': '登录',
    'login.form.register': '注册账号',
    'login.banner.slogan1': '梦想还是要有的，万一实现了呢。',
    'login.banner.subSlogan1': '生活若剥去理想、梦想、幻想，那生命便只是一堆空架子。',
    'login.banner.slogan2': '滴水穿石不是靠力，而是因为不舍昼夜。',
    'login.banner.subSlogan2': '只要持续地努力，不懈地奋斗，就没有征服不了的东西。',
    'login.banner.slogan3': '生活中并非全是玫瑰花，还有刺人的荆棘。',
    'login.banner.subSlogan3': '每一次努力的背后，必有加倍的赏赐。'
  }
};
export default i18n;